export default "__VITE_ASSET__Mpey1cHn__"